import React, { Component } from "react";
import { Icon } from "@iconify/react";
import javascriptIcon from "@iconify/icons-logos/javascript";
import htmlIcon from "@iconify/icons-logos/html-5";
import cssIcon from "@iconify/icons-logos/css-3";
import nodeIcon from "@iconify/icons-logos/nodejs";
import bootIcon from "@iconify/icons-logos/bootstrap";
import azureIcon from "@iconify/icons-logos/azure";
import mongoIcon from "@iconify/icons-logos/mongodb";
import dotnetIcon from "@iconify/icons-logos/dotnet";
import unityIcon from "@iconify/icons-logos/unity";
import expressIcon from "@iconify/icons-logos/express";
import csharpIcon from "@iconify/icons-logos/c-sharp";
import reactIcon from "@iconify/icons-logos/react";
import { Slide } from "react-awesome-reveal";
export default class Skills extends Component {
  render() {
    return (
      <div class="skills" id="skills">
        <Slide delay={.1005}>
        <h2>Skills</h2></Slide>
        <div class="skill-icons">
          <Icon
            icon={javascriptIcon}
            style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
          />
          <Icon
            icon={htmlIcon}
            style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
          />
          <Icon
            icon={cssIcon}
            style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
          />
          <Icon
            icon={nodeIcon}
            style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
          />
          <Icon
            icon="ri:bootstrap-fill"
            style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
          />
          <Icon
            icon={dotnetIcon}
            style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
          />
          <Icon
            icon={mongoIcon}
            style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
          />
          <Icon
            icon="devicon-plain:azuresqldatabase"
            style={{ fontSize: "400%", margin: "9% 5% 0 1%" }}
          />
          <Icon
            icon={unityIcon}
            style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
          />
          <Icon
            icon={expressIcon}
            style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
          />
          <Icon
            icon={reactIcon}
            style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
          />
          <Icon
            icon={csharpIcon}
            style={{ fontSize: "400%", margin: "9% 5% 0 5%" }}
          />
        </div>
      </div>
    );
  }
}
